import type { FormContentItem, Validators } from '@/components/Form/types';

export const hasValidator = (validator: Validators, item: FormContentItem): boolean => {
  if (!item.validators || !Array.isArray(item.validators)) {
    return false;
  }

  return item.validators.some((v) => v.component === validator);
};
